import { useQueryClient } from '@tanstack/react-query'
import { trpc } from '../api/index.js'
import { useAuthStore } from '../stores/authStore.js'
import { useNav } from '../stores/navigationStore.js'

/**
 * Comutarea punctului de lucru — o SINGURĂ implementare, folosită de selectorul din bara
 * laterală și de bannerul pentru deep-link-urile care aparțin altui punct de lucru.
 *
 * `setSession` declanșează resetarea stării legate de tenant (navigare, alerte — vezi
 * `registerSessionScopeReset` din App.tsx). Cache-ul React Query se RESETEAZĂ, nu se
 * invalidează: invalidarea lasă vizibile datele vechi până la refetch, deci pentru o clipă
 * vedeai datele punctului vechi sub eticheta celui nou. `resetQueries` golește datele,
 * anulează cererile în zbor (răspunsurile vechiului punct nu mai ajung în cache) și
 * re-cere doar query-urile montate — inclusiv cele din bara laterală, care nu se remontează
 * (cu `clear()` rămâneau legate de query-uri scoase din cache și nu se mai actualizau).
 */
export function useComutaPunctLucru(opts: { onSuccess?: () => void; onError?: (e: unknown) => void } = {}) {
  const queryClient = useQueryClient()
  const mutatie = trpc.auth.switchPunctLucru.useMutation({
    onSuccess: (data) => {
      const session = useAuthStore.getState().session
      if (!session) return
      useAuthStore.getState().setSession({
        ...session,
        punctLucruId: data.punctLucruId,
        punctCodul: data.codul ?? '',
        punctDenumire: data.denumire ?? '',
        storeDbId: data.storeDbId,
        token: data.token,
      })
      void queryClient.resetQueries()
      opts.onSuccess?.()
    },
    onError: (e) => opts.onError?.(e),
  })
  // Comutarea remontează conținutul și resetează navigarea → un formular nesalvat (ex. wizardul
  // de contract) s-ar pierde fără întrebare. Respectăm aceeași gardă ca navigarea obișnuită
  // (`useGardaNavigare` → navGuard): dacă utilizatorul nu confirmă, nu comutăm.
  const mutate: typeof mutatie.mutate = (vars, o) => {
    const garda = useNav.getState().navGuard
    if (garda && !garda()) return
    mutatie.mutate(vars, o)
  }
  return { ...mutatie, mutate }
}
